"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require("babel-runtime/helpers/objectWithoutProperties");

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactDom = require("react-dom");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SelectMultipleWrapNew = function SelectMultipleWrapNew(WrappedComponent) {
    var Wrapper = function (_Component) {
        (0, _inherits3.default)(Wrapper, _Component);

        function Wrapper(props) {
            (0, _classCallCheck3.default)(this, Wrapper);

            var _this = (0, _possibleConstructorReturn3.default)(this, (Wrapper.__proto__ || (0, _getPrototypeOf2.default)(Wrapper)).call(this, props));

            _this.refSelect = null;
            _this.setRef = _this.setRef.bind(_this);
            return _this;
        }

        (0, _createClass3.default)(Wrapper, [{
            key: "getSelectedCount",
            value: function getSelectedCount() {
                if (!this.refSelect) {
                    return 0;
                }
                var value = this.refSelect.getInstance().state.value;
                var n = value && value.length || 0;
                return n;
            }
        }, {
            key: "setRef",
            value: function setRef(ref) {
                this.refSelect = ref;
            }
        }, {
            key: "getRef",
            value: function getRef() {
                return this.refSelect;
            }
        }, {
            key: "useNewMultipleSelect",
            value: function useNewMultipleSelect() {
                var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

                return props.multiple && props.compact;
            }
        }, {
            key: "render",
            value: function render() {
                var newProps = (0, _objectWithoutProperties3.default)(this.props, []);

                if (this.useNewMultipleSelect()) {
                    newProps.className = (0, _classnames2.default)(newProps.className, "cn-select-multi-compact");
                }
                return _react2.default.createElement(WrappedComponent, (0, _extends3.default)({}, newProps, { ref: this.setRef }));
            }
        }]);
        return Wrapper;
    }(_react.Component);

    return Wrapper;
    // const SelectMultipleWrapNewWithLocale = LocaleProvider(Wrapper);
    // SelectMultipleWrapNewWithLocale.LOCALE = locale;

    // return SelectMultipleWrapNewWithLocale;
};

exports.default = SelectMultipleWrapNew;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-select-field@0.0.22@@alicd/crui-select-field/lib/SelectMultipleWrapNew.js
// module id = 668
// module chunks = 0